import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { CaseInfoResolver } from './features/case-pages/case-info-page/resolvers/case-info.resolver';
import { DsnMasterComponent } from './features/dsn-master/dsn-master.component';
import { LayoutComponent } from './layout/layout.component';
import { QuickNavResolver } from './shared/resolvers/quick-nav.resolver';
import { CivilReferralInfoDeactivateGuard, ReferralInfoDeactivateGuard } from './core/guards/referral-info-deactive.guard';
import { PartySearchResultGuard } from './core/guards/party-search-result.guard';
import { AgencyHomeResolver } from './features/agency-home/resolver/agency-home.resolver';
import { CivilCaseResolver } from './features/case-pages/civil-case-page/resolvers/civil-case.resolver';
import { ReferralInfoDetailsResolver, ReferralInfoTabResolver } from './features/referral-pages/referral-info/resolver/referral-info.resolver';
import { DefendantReferralResolver } from './features/referral-pages/referral-info/resolver/defendant.resolver';
import { CivilCaseReferralResolver } from './features/referral-pages/civil-case-referral-page/resolvers/civil-case-referral.resolver';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    resolve: {
      quickNavSettings: QuickNavResolver
    },
    canActivate: [AuthGuard], // protect everything inside Layout
    children: [
      {
        path: '',
        redirectTo: 'agency-home',
        pathMatch: 'full'
      },
      {
        path: 'agency-home',
        loadComponent: () => import('./features/agency-home/agency-home.component').then(m => m.AgencyHomeComponent),
        data: { pageName: ['Agency Portal'] },
        resolve: {
          isReferralHistoryRecord: AgencyHomeResolver
        }
      },
      {
        path: 'test',
        loadComponent: () => import('./features/test/test.component').then(m => m.TestComponent)
      },
      {
        path: 'case-info/:caseId',
        loadComponent: () => import('./features/case-pages/case-info-page/case-info-page.component').then(m => m.CaseInfoPageComponent),
        data: { pageName: ['data', 'Agency Portal'] },
        resolve: {
          data: CaseInfoResolver,
        },
      },
      {
        path: 'civil-case/:caseId',
        title: 'Case Information Search',
        loadComponent: () => import('./features/case-pages/civil-case-page/civil-case-page.component').then(m => m.CivilCasePageComponent),
        data: { pageName: ['data', 'Agency Portal'] },
        resolve: {
          data: CivilCaseResolver,
        },
      },
      {
        path: 'referral-info/:sequeceNumber',
        loadComponent: () => import('./features/referral-pages/referral-info/referral-info.component').then(m => m.ReferralInfoComponent),
        data: { pageName: ['data', 'Agency Portal'] },
        canDeactivate: [ReferralInfoDeactivateGuard],
        resolve: {
          tabDetails: ReferralInfoTabResolver,
          systemValues: DefendantReferralResolver,
          referralDetails: ReferralInfoDetailsResolver
        }
      },
      {
        path: 'civil-referral-info/:sequeceNumber',
        loadComponent: () => import('./features/referral-pages/civil-case-referral-page/civil-case-referral-page.component').then(m => m.CivilCaseReferralPageComponent),
        canDeactivate: [CivilReferralInfoDeactivateGuard],
        data: { pageName: ['data', 'Agency Portal'] },
        resolve: {
          data: CivilCaseReferralResolver,
        },
      },
      {
        path: 'court-list/:type/:dsn',
        loadComponent: () => import('./features/court-page/court-page.component').then(m => m.CourtPageComponent),
        data: { pageName: ['Court Dates', 'Agency Portal'] }
      },
      {
        path: 'officers',
        component: DsnMasterComponent,
        children: [
          {
            path: 'list',
            loadComponent: () => import('./features/dsn-master/components/officer-list/officer-list.component').then(m => m.OfficerListComponent),
            data: { pageName: ['DSN Master', 'Agency Portal'] }
          },
          {
            path: 'add',
            loadComponent: () => import('./features/dsn-master/components/add-officer/add-officer.component').then(m => m.AddOfficerComponent),
            data: { pageName: ['Add New', 'DSN Master', 'Agency Portal'] }

          },
          {
            path: 'edit',
            loadComponent: () => import('./features/dsn-master/components/edit-officer/edit-officer.component').then(m => m.EditDsnComponent),
            data: { pageName: ['data', 'DSN Master', 'Agency Portal'] }
          },
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'list'
          }
        ]
      },
      {
        path: 'search',
        loadComponent: () => import('./features/party-search/party-search-page/party-search-page.component').then(m => m.PartySearchPageComponent),
        data: { pageName: ['Search - Case Information Search', 'Agency Portal'] }
      },
      {
        path: 'party-search-result',
        canActivate: [PartySearchResultGuard],
        loadComponent: () => import('./features/party-search/party-search-result/party-search-result.component').then(m => m.PartySearchResultComponent),
        data: { pageName: ['Search - Party Search Result', 'Agency Portal'] }
      },
      {
        path: 'multifile-search-result',
        loadComponent: () => import('./features/multisearch-result-page/multisearch-result-page.component').then(m => m.MultisearchResultPageComponent),
        data: { pageName: ['Search - Case Search Results', 'Agency Portal'] }
      },
    ]
  },
  {
    path: 'login',
    data: { Page: "Login" },
    loadComponent: () => import('./features/auth/auth.component').then(m => m.AuthComponent)
  },
  {
    path: 'change-password',
    data: { Page: "ChangePassword" },
    loadComponent: () => import('./features/auth/auth.component').then(m => m.AuthComponent)
  },
  {
    path: 'verify-authentication',
    data: { Page: "VerifyAuthentication" },
    loadComponent: () => import('./features/auth/auth.component').then(m => m.AuthComponent)
  },
  {
    path: 'not-authorized',
    loadComponent: () => import('./features/auth/components/un-authorized/un-authorized.component').then(m => m.UnAuthorizedComponent)
  },


  {
    path: '**',
    redirectTo: ''
  }
];